import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
import FormControlFieldWrapper from "../../FormControl/FormControl/FormControlWrapper.js";
/* empty css                      */
const PhoneNumberInput = ({
  formControlWrapperProps,
  id,
  required,
  className,
  inputClasses,
  value,
  PhoneNumberInputComponent,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement(FormControlFieldWrapper, { ...formControlWrapperProps, required }, /* @__PURE__ */ React.createElement(
    PhoneNumberInputComponent,
    {
      ...{
        id,
        className: inputClasses,
        countrySelectProps: {
          arrowComponent: () => /* @__PURE__ */ React.createElement(Icon, { className: "PhoneInputCountry--icon", name: "chevron-down" })
        },
        focusInputOnCountrySelection: false,
        ...rest,
        /* pass undefined instead of empty string, because
        empty string will also reset the selected country */
        value: value || void 0,
        type: "tel"
      }
    }
  ));
};
export {
  PhoneNumberInput as default
};
//# sourceMappingURL=PhoneNumberInput.js.map
